import React from 'react';
import Overview from '../components/Overview';

class Main extends React.Component {
  render()  {
    return (  
      <div>
        <Overview />
      </div>
    );
  }
}

export default Main;


// WEBPACK FOOTER //
// ./src/containers/Main.js